<template>
  <div>
    <PinkPuk />
    <SimCardBlock />
    <SimCardUnBlock />
    <SimCardActivateGPRS />
    <SimCardDeActivateGPRS />
    <CommingSoonPop />
    <SimCardSWAP />
    <SimCardMe2u/>
    <MyNumbers />
  </div>
</template>

<script>
import PinkPuk from "./PinPuk";
import SimCardBlock from "./SimCardBlock";
import SimCardUnBlock from "./SimCardUnBlock";
import SimCardActivateGPRS from "./SimCardActivateGPRS";
import SimCardDeActivateGPRS from "./SimCardDeActivateGPRS";
import CommingSoonPop from "./CommingSoonPop";
import SimCardSWAP from "./SimCardSWAP";
import SimCardMe2u from "./SimCodeMe2u.vue";
import MyNumbers from './MyNumbers.vue'

export default {
  name: "SimCardComponents",
  components: {
    PinkPuk,
    SimCardBlock,
    SimCardUnBlock,
    SimCardActivateGPRS,
    SimCardDeActivateGPRS,
    CommingSoonPop,
    SimCardSWAP,
    SimCardMe2u,
    MyNumbers
  },
};
</script>